import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import Button from "apollo-react/components/Button";
import Grid from "apollo-react/components/Grid";
import SwitchInput from "../../common/Form/switchInput";
import { renderInputComponent } from "../../common/Form/renderInputComponent";
const DynamicForm = ({persona}) => {
	const [formFields, setFormFields] = useState([]);
	const [formData, setFormData] = useState({});
	const [isUpdate, setIsUpdate] = useState(false);
	const [loading, setLoading] = useState(true);
	const [resp, setResp] = useState("");
	const [token, setToken] = useState("");
	const [t] = useTranslation();
	const { id } = useParams();
	const [initialValues, setInitialValues] = useState({});
	let navigate = useNavigate();
	// Fetch form fields and data (if updating) from the backend
	useEffect(() => {
		const fetchFormMetadata = async () => {
			try {
				const formFields = [
					{
						name: "username",
						type: "text",
						label: "Username",
						required: true,
						fullWidth: true,
					},
					{
						name: "email",
						type: "email",
						label: "Email",
						required: true,
						fullWidth: true,
					},
					{
						name: "password",
						type: "password",
						label: "Password",
						required: false,
						fullWidth: true,
					},
				];
				setFormFields(formFields);
				console.log("form:", formFields);
				if (id) {
					// If we have an ID, fetch data for updating
					setIsUpdate(true);
					const { data: recordData } = await axiosInstance.get(`/api/endUsers/${id}`, {
						headers: {
							authorization: token,
						},
					});

					setFormData(recordData);
					console.log("data:", recordData);
				}
				// const { data: fieldDefinitions } = await axiosInstance.get('/api/form-fields');
				// setFormFields(fieldDefinitions);

				setLoading(false);
			} catch (err) {
				setResp(t("Error fetching form metadata or data"));
				console.error(t("Error fetching form metadata or data: "), err);
				setLoading(false);
			}
		};

		fetchFormMetadata();
	}, [id, t]);

	useEffect(() => {
		const initialValues = formFields.reduce((acc, field) => {
			acc[field.name] = formData[field.name] || "";
			return acc;
		}, {});

		setInitialValues(initialValues);
	}, [formFields, formData]);

	// Handle input changes
	const handleChange = (name, value) => {
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	// Handle form submission (Add or Update)
	const handleSubmit = async (e) => {
		console.log("formData", formData);

		try {
			if (isUpdate) {
				// if( formData.password == null ) { formData(l => l.filter(item => item.password == null)); }
				if (!formData.password) delete formData.password;
				axiosInstance
					.put(`/api/endUsers/${id}`, formData, {
						withCredentials: true,
					})
					.then((resp) => {
						toast.success("User Updated Successfully!", {
							position: "top-center",
						});
						navigate(-1);
					})
					.catch((error) => {
						setResp(t("Error updating form"), ":", error);
					});
			} else {
				axiosInstance
					.post("/api/endUsers/", formData)
					.then((resp) => {
						toast.success(t("User Added Successfully!"), {
							position: "top-center",
						});
						setToken("");
						if (resp.data.token) {
							setToken(resp.data.token);
						} else {
							navigate(-1);
						}
					})
					.catch((error) => {
						if (error.response && error.response.status === 400) {
							// Handle the specific error for duplicate email
							toast.error(error.response.data.message, { position: "top-center" });
						} else {
							setResp(t("Error creating form"), ":", error);
						}
					});
			}
		} catch (err) {
			setResp(t("Error submitting form"), ":", err);
			console.error("Error submitting form: ", err);
		}
	};

	if (loading) return <div>Loading...</div>;

	return (
		<div className="content">
			{resp && <p>{resp}</p>}
			<Grid container justifyContent={"center"}>
				<Grid item md={8}>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={handleSubmit}
					>
						{({ handleSubmit, setFieldValue }) => (
							<Form onSubmit={handleSubmit}>
								{formFields.map((field) => (
									<Field key={field.name} name={field.name}>
										{({ field: formikField, meta }) => {
											const handleFieldChange = (value) => {
												console.log("formikField", formikField, value);
												setFieldValue(formikField.name, value);
												handleChange(formikField.name, value);
											};

											return renderInputComponent(
												field,
												formData,
												formikField,
												meta,
												handleFieldChange
											);
										}}
									</Field>
								))}
								<Button variant="primary" type="submit">
									{isUpdate ? "Update" : "Add"} Record
								</Button>
							</Form>
						)}
					</Formik>
					{token && (
						<div className="mt-2 p-2 card">
							<h6>Generated Token:</h6>
							<p className="">{token}</p>
						</div>
					)}
				</Grid>
			</Grid>
		</div>
	);
};

export default DynamicForm;
